import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';

import { CustomField, CustomFieldDropdown, CustomFieldsConfiguration, ConfigGroup } from './custom-fields-models';

import { CustomFieldsService } from './custom-fields.service'
import { CustomFieldUpdaterService } from './custom-fields-updater.service';
//import { WoUpdater, WoUpdaterService } from './wo-updater.service';
import { DatePipe } from '@angular/common';
import { SharedService, Status, RowsPerOptions } from '../.././shared/shared.service';
import { BaseComponent } from '../base.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    // moduleId: module.id,
    selector: 'custom-fields',
    templateUrl: 'custom-fields.component.html'
})
export class CustomFieldsComponent extends BaseComponent implements OnChanges, OnInit {

    @Input() eid: number;
    @Input() pid: number;
    @Input() col: number;    
    @Input() recordId: number;
    @Input() companyId: number;
    @Input() singleColumn:boolean;
    @Input() fromcustomer?: boolean;
    @Input() parentpageId?: number;

    @Input() co: CustomFieldsConfiguration;
    customFieldsConfiguration = new CustomFieldsConfiguration();

    customFields: CustomField[] = [];
    CustomFieldDropdown: CustomFieldDropdown[] = [];
    isValid: boolean;
    colStyle: string;
    col1st: string;
    col2nd: string;
    configGroup: ConfigGroup[];
    yearRange: string;
    dateFormatStr: string;
    coll1st: string;
    coll2nd: string;
    //constructor(private customFieldsService: CustomFieldsService) { }
    constructor(protected sharedService: SharedService,protected translate: TranslateService, private customFieldsService: CustomFieldsService, private updater: CustomFieldUpdaterService, private datePipe: DatePipe) {
        super(sharedService,translate);
        this.yearRange = sharedService.yearRange;
        
    }
    ngOnChanges(changes: SimpleChanges) {
       if (!this.dateFormatStr)
       this.getDateFormats();
      this.createCustomControls();
    }
    ngOnInit() {
    }
    createCustomControls() {
        var cos = this.co;
        this.colStyle = this.col == 1 ? '' : 'col-md-6';
        if (this.eid == 6 && this.pid == 15 && this.col == 0) {
            this.col1st = "col-xs-3";
            this.col2nd = "col-xs-9";
        }
        else {
            this.col1st = "col-xs-4";
            this.col2nd = "col-xs-8";
        }
        if(this.fromcustomer)
        {
            if(this.parentpageId==1)//customer detail
            {
                this.coll1st = "col-xs-5";
                this.coll2nd = "col-xs-7";
            }
            else if(this.parentpageId==2)//create work order
            {
                this.coll1st = "col-xs-3";
                this.coll2nd = "col-xs-9";
            }
            else if(this.parentpageId==3)//manage work order,tech jobs,user,technician,vendor
            {
                this.coll1st = "col-xs-4";
                this.coll2nd = "col-xs-8";
            }
        }
        // alert(this.colStyle);
        if (typeof cos != "undefined") {
            
            this.customFieldsConfiguration = cos;

            this.customFieldsConfiguration.CustomFields.forEach(x => {
                if (x.FieldTypeId == 3 && x.Value) {
                    x.Value = new Date(x.Value);
                }
                else if (x.FieldTypeId == 7 && x.Value) {                            
                    x.Value = this.datePipe.transform(x.Value, 'MM/dd/yyyy') + " " + this.datePipe.transform(x.Value, 'shortTime');
                }

            });
            if (this.col == 2 || this.col == 3 || this.col == 4)
                this.createGroup(this.customFieldsConfiguration);
            this.updater.update.emit({ index: 5, value: this.customFieldsConfiguration });
        }
        else {            
            this.customFieldsService.getCustomFields(this.eid, this.pid, this.recordId, this.companyId,super.globalInfo().LoginId).subscribe(data => {
                console.log("eid" + this.eid + ",pid" + this.pid + ",recordId" + this.recordId + ",companyId" + this.companyId);
                console.log('getCustomFields');
                console.log(data);
                if (data.length > 0) {
                    this.customFieldsConfiguration = data[0];

                    this.customFieldsConfiguration.CustomFields.forEach(x => {
                        if (x.FieldTypeId == 3 && x.Value) {
                            x.Value = new Date(x.Value);
                        }
                       else if (x.FieldTypeId == 7 && x.Value) {                            
                            x.Value = this.datePipe.transform(x.Value, 'MM/dd/yyyy') + " " + this.datePipe.transform(x.Value, 'shortTime');
                        }
                    });
                    if (this.col == 2 || this.col == 3 || this.col == 4)
                        this.createGroup(this.customFieldsConfiguration);
                    this.updater.update.emit({ index: 5, value: this.customFieldsConfiguration });
                }
            });
        }
    }
    createGroup(fields: CustomFieldsConfiguration) {debugger;

        var cfields = fields.CustomFields;
        var configGrp: ConfigGroup[] = new Array(cfields.length);

        if (this.col == 2 && fields != undefined && fields.CustomFields != undefined) {
            let i: number = 1;
            var num = cfields.length / 2;
            while (num > (i - 1)) {
                configGrp[i] = new ConfigGroup;
                configGrp[i].CustomFieldsGroup = cfields.splice(0, 2);
                i++;
            }
        }
        else if (this.col == 3 && fields != undefined && fields.CustomFields != undefined) {
            let i: number = 1;
            var num = cfields.length / 3;
            while (num > (i - 1)) {
                configGrp[i] = new ConfigGroup;
                configGrp[i].CustomFieldsGroup = cfields.splice(0, 3);
                i++;
            }
        }
        else if (this.col == 4 && fields != undefined && fields.CustomFields != undefined) {
            let i: number = 1;
            var num = cfields.length / 4;
            while (num > (i - 1)) {
                configGrp[i] = new ConfigGroup;
                configGrp[i].CustomFieldsGroup = cfields.splice(0, 4);
                i++;
            }
        }
        this.configGroup = this.cleanArray(undefined, configGrp);
        this.configGroup.forEach(e => {
            e.CustomFieldsGroup.forEach(f => {
                fields.CustomFields.push(f);
            });
        });
        // this.configGroup = configGrp;
    }
    cleanArray(deleteValue, group: ConfigGroup[]) {

        for (var i = 0; i < group.length; i++) {
            if (group[i] == deleteValue) {
                group.splice(i, 1);
                i--;
            }
        }

        return group;
    };
    ngOnDestroy() {
        this.updater.update.emit({ index: 5, value: this.customFieldsConfiguration });
    }
    NumberValidation(e) {
        debugger;
        console.log(e.keyCode);
        if (e.keyCode != 8 && e.keyCode != 0 && (e.keyCode < 48 || e.keyCode > 57)) {
            // $("#errmsg").html("Enter only numeric values in this field").show().fadeOut(3500);          
            return false;
        }
    }
    private getDateFormats() {
        let culture = this.sharedService.globalInfo().Culture;
        switch (culture) {
            case 'en-US':
                this.dateFormatStr = 'm/d/yy';
                break;
            case 'en-GB' || 'fr' || 'fr-FR' || 'ar-OM' || 'ar-SA':
                this.dateFormatStr = 'dd/mm/yy';
                break;
            case 'en-SG':
                this.dateFormatStr = 'd/m/yy';
                break;
        }
    }
}